import React from 'react';
import Tabs from '../hooks/tabs';
import BasicAuthErrorsWrapper from '../errors/BasicAuthErrorsWrapper';
import BasicErrorsWrapper from '../errors/BasicErrorsWrapper';

const TabChangeContainer = ({
  canAccess,
  children,
  description,
  entity,
  exists,
  isDirty,
  name,
  onChange,
  readErrors,
  url,
}) => {
  Tabs.useTabChange(onChange, url, name, description, isDirty);
  return (
    <BasicAuthErrorsWrapper errors={readErrors}>
      <BasicErrorsWrapper canAccess={canAccess} errors={readErrors} exists={exists} entity={entity}>
        { children }
      </BasicErrorsWrapper>
    </BasicAuthErrorsWrapper>
  );
};

export default TabChangeContainer;
